import React from 'react';
import styled from 'styled-components';
import { Card, sa } from '../../../components/superAdminUi';

// At-a-glance panel for the school-edit wizard, on the shared Super Admin design system: the
// school facts plus the save-gating hint.
const RailCard = styled(Card)`
  position: sticky;
  top: 16px;
  font-family: ${sa.font.family};
`;

const RailHeading = styled.div`
  font-weight: ${sa.font.bold};
  font-size: 16px;
  color: ${sa.color.text};
  margin-bottom: 16px;
`;

const RailSection = styled.div`
  & + & {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid ${sa.color.stroke};
  }
`;

const RailLabel = styled.div`
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-size: 11px;
  font-weight: ${sa.font.bold};
  color: ${sa.color.textGray};
  margin-bottom: 8px;
`;

const FactRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
`;

const FactLabel = styled.span`
  font-size: 13px;
  color: ${sa.color.textGray};
`;

const FactValue = styled.span`
  font-size: 13px;
  font-weight: ${sa.font.semibold};
  color: ${sa.color.text};
  text-align: right;
`;

const GatingHint = styled.div`
  margin-top: 16px;
  padding: 8px 12px;
  border: 1px solid ${sa.color.pink};
  border-radius: ${sa.radius.sm};
  background: ${sa.color.groupBg};
  color: ${sa.color.pink};
  font-size: 12px;
  font-weight: ${sa.font.semibold};
  line-height: 1.4;
`;

const Fact = ({ label, value }) => (
  <FactRow>
    <FactLabel>{label}</FactLabel>
    <FactValue>{value || '—'}</FactValue>
  </FactRow>
);

export default function SummaryRail({ values = {}, blocked = false }) {
  return (
    <RailCard>
      <RailHeading>Summary</RailHeading>

      <RailSection>
        <RailLabel>School</RailLabel>
        <Fact label="School" value={values.Name} />
        <Fact label="URN" value={values.Urn} />
        <Fact label="Type" value={values.SchoolType} />
        <Fact label="Country" value={values.Country} />
      </RailSection>

      {blocked && (
        <GatingHint>A school with this name already exists — resolve it before saving.</GatingHint>
      )}
    </RailCard>
  );
}
